"use client";

import { SESSION_ACTIVITY_STORAGE_KEY } from "@/lib/session-policy";

export function recordSessionActivity(now = Date.now()) {
  try {
    window.localStorage.setItem(SESSION_ACTIVITY_STORAGE_KEY, String(now));
  } catch {
    // Browser storage can be unavailable; the in-memory guard still applies.
  }
}

export function clearSessionActivity() {
  try {
    window.localStorage.removeItem(SESSION_ACTIVITY_STORAGE_KEY);
  } catch {
    // A failed cleanup must not prevent server-side sign-out.
  }
}
